import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Wraps admin-only pages. Validates the stored admin token against the backend.
 * Redirects to /admin/login if not authenticated.
 */
export default function AdminGuard({ children }) {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("proctorly_admin_token");
    if (!token) { navigate("/admin/login", { replace: true }); return; }
    api.adminMe()
      .then(() => setChecked(true))
      .catch(() => {
        localStorage.removeItem("proctorly_admin_token");
        localStorage.removeItem("proctorly_admin_email");
        navigate("/admin/login", { replace: true });
      });
  }, [navigate]);

  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--kl-navy-deep)" }}>
        <div className="font-mono-kl text-xs uppercase tracking-widest text-white/40 animate-pulse">Authenticating…</div>
      </div>
    );
  }

  return children;
}
